module.exports = __webpack_public_path__ + "static/img/136009556.4a97d96f.png";